import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import FullNavigation from "../navigations";
import LoginLayout from "../pages/account/login";
import UsLayout from "../pages/users/usLayout";
import InnerUsPage from "../pages/users/InnerUsPage";
import UserPageLayout from "../pages/AdminsPage/userPageLayout";
import InnerUsersPage from "../pages/AdminsPage/innerUsersPage";
import FaqLayout from "../pages/faq/FaqLayout";
import InnerFaqPage from "../pages/faq/innerFaqPage";
import Countries from "../pages/countries/Countries";
import InnerCountries from "../pages/countries/InnerCountries";
import AbOfficesLayout from "../pages/AbOffices/AbOfficesLayoutLayout";
import InnerAbOfficesPage from "../pages/AbOffices/innerAbOfficesPage";
import FilialLayout from "../pages/Filials/FilialLayout";
import InnerFilialPage from "../pages/Filials/InnerFilialPage";
import Flights from "../pages/flights/Flights";
import InnerFlightsPage from "../pages/flights/InnerFlightsPage";
import Archive from "../pages/archive/Archive";
import WarehousePackage from "../pages/Packages/InWarehouse/WarehousePackage";
import SentPackage from "../pages/Packages/SentPackages/SentPackage";
import AppeardPackages from "../pages/Packages/AppeardPackages/AppeardPackages";
import PassedPackages from "../pages/Packages/PassedPackages/PassedPackages";

import { AdminPrimaryContext } from "../adminContext/AdminContext";
import {
  isWarehouseOperator,
  roleLandingPath,
  isOpsOperator,
  isSpaceCargoViewer,
} from "../../../data/adminRoles";

import "react-toastify/dist/ReactToastify.css";
import Support from "../pages/support/Support";
import PanelMessages from "../pages/messages/PanelMessages";
import SendMessagePanel from "../pages/messages/SendMessagePanel";
import DeclarationService from "../pages/declarationService/DeclarationService";
import ExportsPage from "../pages/ExportsPage/ExportsPage";
import PopupsUpdate from "../pages/popups/PopupsUpdate";
import Popups from "../pages/popups/Popups";
import BlogsAdmin from "../pages/BlogsAdmin/BlogsAdmin";
import InnerBlogAdmin from "../pages/BlogsAdmin/InnerBlogAdmin";
import PromoCodes from "../pages/promo-codes/PromoCodes";
import InnerPromoCodes from "../pages/promo-codes/InnerPromoCodes";
import AdminReviews from "../pages/AdminReviews/AdminReviews";
import OnWayPage from "../pages/OnWay/OnWayPage";
import ShopsPage from "../pages/Shops/ShopsPage";
import MessageTemplatesPage from "../pages/MessageTemplates/MessageTemplatesPage";
import SpaceCargoPage from "../pages/SpaceCargo/SpaceCargoPage";

const AdminRouter = () => {
  //get current page url
  const location = useLocation();
  //correct navigation
  const navigate = useNavigate();
  //check if user is authorized
  const { isAuthorized, user } = useContext(AdminPrimaryContext);

  // On a bare /admin path, go straight to the login screen if the admin
  // hasn't authenticated yet — otherwise land them on the page their role
  // can actually see.
  useEffect(() => {
    if (location.pathname === "/admin" || location.pathname === "/admin/") {
      if (isAuthorized && user?.role) {
        navigate(roleLandingPath(user.role));
      } else {
        navigate("login");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized, user?.role]);

  return (
    <div>
      {isAuthorized && location.pathname !== "/admin/login" && (
        <FullNavigation />
      )}
      <Routes>
        <Route path="login" element={<LoginLayout />} />
        {isAuthorized && (
          <>
            {user.role === "100" && (
              <>
                <Route path="users" element={<UsLayout />} />
                <Route path="users/:siteUsersId" element={<InnerUsPage />} />

                <Route path="admins" element={<UserPageLayout />} />
                <Route path="admins/:usersId" element={<InnerUsersPage />} />

                <Route path="faq" element={<FaqLayout />} />
                <Route path="faq/:faqId" element={<InnerFaqPage />} />

                <Route path="countries" element={<Countries />} />
                <Route
                  path="countries/:countryId"
                  element={<InnerCountries />}
                />

                <Route path="ab-office" element={<AbOfficesLayout />} />
                <Route
                  path="ab-office/:officeId"
                  element={<InnerAbOfficesPage />}
                />

                <Route path="filial" element={<FilialLayout />} />
                <Route path="filial/:filialId" element={<InnerFilialPage />} />

                <Route path="popup" element={<Popups />} />
                <Route path="popup/:popupId" element={<PopupsUpdate />} />

                <Route path="flights" element={<Flights />} />
                <Route
                  path="flights/:flightsId"
                  element={<InnerFlightsPage />}
                />

                <Route path="archive" element={<Archive />} />

                <Route path="in-warehouse" element={<WarehousePackage />} />
                <Route path="sent" element={<SentPackage />} />
                <Route path="appeard" element={<AppeardPackages />} />
                <Route path="deliverd" element={<PassedPackages />} />

                <Route path="support" element={<Support />} />
                <Route path="messages" element={<PanelMessages />} />
                <Route path="messages/:userId" element={<SendMessagePanel />} />

                <Route path="admin-blogs" element={<BlogsAdmin />} />
                <Route
                  path="admin-blogs/:blogId"
                  element={<InnerBlogAdmin />}
                />

                <Route
                  path="declaration-service"
                  element={<DeclarationService />}
                />

                <Route path="promo-codes" element={<PromoCodes />} />
                <Route
                  path="promo-codes/:codeId"
                  element={<InnerPromoCodes />}
                />

                <Route path="reviews" element={<AdminReviews />} />

                <Route path="onway" element={<OnWayPage />} />
                <Route path="spacecargo" element={<SpaceCargoPage />} />
                <Route path="shops" element={<ShopsPage />} />
                <Route path="message-templates" element={<MessageTemplatesPage />} />
              </>
            )}

            {/*
              Warehouse operators (Turkey, Sea/Air China, USA, Greece) see the
              full pack lifecycle for their warehouse. The backend scopes each
              endpoint by admin.abroad_office_id, so no cross-warehouse leak.
            */}
            {isWarehouseOperator(user.role) && (
              <>
                <Route path="in-warehouse" element={<WarehousePackage />} />
                <Route path="sent" element={<SentPackage />} />
                <Route path="appeard" element={<AppeardPackages />} />
                <Route path="deliverd" element={<PassedPackages />} />
              </>
            )}

            {/* Georgia operations: the five pages, nothing else — no exports,
                no users, no settings. */}
            {isOpsOperator(user.role) && (
              <>
                <Route path="in-warehouse" element={<WarehousePackage />} />
                <Route path="sent" element={<SentPackage />} />
                <Route path="appeard" element={<AppeardPackages />} />
                <Route path="deliverd" element={<PassedPackages />} />
                <Route path="onway" element={<OnWayPage />} />
              </>
            )}

            {/* SpaceCargo viewer: that one page, read-only. */}
            {isSpaceCargoViewer(user.role) && (
              <Route path="spacecargo" element={<SpaceCargoPage readOnly />} />
            )}

            {!isOpsOperator(user.role) && !isSpaceCargoViewer(user.role) && (
              <Route path="by-flights" element={<ExportsPage />} />
            )}

            {/* <Route path="admin-page" element={<EditProfile />} /> */}
          </>
        )}
      </Routes>
    </div>
  );
};

export default AdminRouter;
